import { useEffect } from 'react';

const useClickOutside = ({ isOpen, anchorRef, popperRef, onClose }) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!isOpen) return;

      const path = event.composedPath?.() || [];
      const clickedInsidePopper = path.includes(popperRef.current);
      const clickedAnchor = path.includes(anchorRef.current);

      const clickedMuiDropdown = path.some(
        (el) =>
          el instanceof HTMLElement &&
          (el.className.includes('MuiPaper-root') || el.className.includes('MuiPopover-root'))
      );

      if (!clickedInsidePopper && !clickedAnchor && !clickedMuiDropdown) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, anchorRef, popperRef, onClose]);
};

export default useClickOutside;
